import Button from '@doordash/component-button'
import * as React from 'react'
import {
  ANDROID_DASHER_APP_URL,
  DASHER_APP_URL,
  IOS_DASHER_APP_URL,
} from '../../../constants'
import t from './strings'

export enum AppDownloadOS {
  IOS = 'IOS',
  ANDROID = 'ANDROID',
  DESKTOP = 'DESKTOP',
}

type AppDownloadButtonTypesProps = {
  os: AppDownloadOS
  onClick?: () => void
  tag?: string
  target?: string
  size?: any
  type?: string
  isInline?: boolean
  name?: string
}

const osMap = {
  [AppDownloadOS.ANDROID]: {
    href: ANDROID_DASHER_APP_URL,
    name: 'Android',
  },
  [AppDownloadOS.IOS]: {
    href: IOS_DASHER_APP_URL,
    name: 'iOS',
  },
  // Blank name for 'Download App'
  [AppDownloadOS.DESKTOP]: {
    href: DASHER_APP_URL,
    name: '',
  },
}
class AppDownloadButton extends React.Component<AppDownloadButtonTypesProps> {
  public static defaultProps = {
    onClick: console.log,
  }

  public render() {
    const { href, name } = osMap[this.props.os]
    const customName = this.props.name
    return (
      <Button {...this.props} href={href} tag="a" target="_blank">
        {customName || `${t.download()} ${name} ${t.app()}`}
      </Button>
    )
  }
}

export default AppDownloadButton
